export const tabIcons: Record<string, string> = {
  dashboard: 'mdi:view-dashboard-outline',
  people: 'ic:baseline-person',
  structure: 'ic:outline-account-tree',
  access: 'ic:round-key',
  ministries: 'ic:outline-meeting-room',
  locations: 'mdi:map-marker-outline',
  users: 'mdi:account-multiple-outline',
  settings: 'mdi:cog-outline',
};
